export default "__VITE_ASSET__Cs3wBPB$__"